export default __webpack_public_path__ + "static/media/earth.19bf9b29.png";